{
  "title": "How did we do?",
  "lead": "Rate a service you used. Your answers help the office improve. They are anonymous unless you choose otherwise.",
  "whyTitle": "Why we ask",
  "whyBody": "Under the Ease of Doing Business Act (RA 11032), government offices measure how satisfied their clients are and act on it. Each office sees the results for its own services.",
  "service": "Service you used",
  "chooseService": "Choose a service",
  "otherService": "Another service (not listed)",
  "office": "Office",
  "chooseOffice": "Choose the office",
  "municipalOffices": "Municipal offices",
  "barangays": "Barangays",
  "serviceName": "What was the service?",
  "serviceNameHint": "For example: \"Barangay clearance\".",
  "ratingsTitle": "Your rating",
  "q_overall": "Overall, how satisfied are you?",
  "q_ease": "How easy was the process?",
  "q_time": "How reasonable was the time it took?",
  "q_courtesy": "How courteous and helpful was the staff?",
  "short_overall": "Overall",
  "short_ease": "Ease",
  "short_time": "Time",
  "short_courtesy": "Courtesy",
  "optional": "optional",
  "r1": "Very poor",
  "r2": "Poor",
  "r3": "Okay",
  "r4": "Good",
  "r5": "Very good",
  "clearRating": "Clear",
  "comment": "Comments or suggestions",
  "commentHint": "What went well? What should change?",
  "includeName": "Include my name ({name}) so the office knows who sent it",
  "complaint": "Treat this as a formal complaint",
  "complaintHint": "The office must act on it. You get a reference number and can follow it in My requests.",
  "complaintSignIn": "To file a formal complaint, sign in so the office can reply and you can follow it.",
  "complaintComment": "Describe what happened",
  "complaintCommentHint": "When it happened, what you were asked for, and what you expected.",
  "chooseServiceError": "Choose the service you used.",
  "overallError": "Give an overall rating.",
  "submit": "Send feedback",
  "submitComplaint": "Send complaint",
  "sending": "Sending…",
  "thanksTitle": "Thank you!",
  "thanksBody": "Your feedback was sent to {office}.",
  "complaintTitle": "Your complaint was filed",
  "complaintBody": "Reference {ref}. The office has up to 7 working days to act on it. You can follow it in My requests.",
  "trackComplaint": "Follow my complaint",
  "another": "Rate another service",
  "hotlineTitle": "Still not resolved?",
  "hotlineBody": "You can also contact the national 8888 Citizens' Complaint Center: call 8888 or visit 8888.gov.ph.",
  "insightsTitle": "Client satisfaction",
  "insightsLead": "What residents say about this office's services. Answers are anonymous unless the resident chose to include their name.",
  "range": "Period",
  "range30": "30 days",
  "range90": "90 days",
  "range365": "12 months",
  "from": "From",
  "to": "To",
  "responses": "Responses",
  "overallAvg": "Overall rating",
  "outOf5": "{value} / 5",
  "complaints": "Formal complaints",
  "viewComplaints": "Open in Requests",
  "averagesTitle": "Average per question",
  "notAnswered": "No answers",
  "distribution": "How residents rated",
  "question": "Question",
  "showTable": "Show as table",
  "hideTable": "Show as chart",
  "colRating": "Rating",
  "colCount": "Responses",
  "ratingN": "{n} · {label}",
  "byService": "By service",
  "colService": "Service",
  "colResponses": "Responses",
  "colOverall": "Overall",
  "latest": "Latest comments",
  "noComment": "No comment",
  "anonymous": "Anonymous",
  "complaintRef": "Complaint {ref}",
  "exportCsv": "Export CSV",
  "empty": "No feedback in this period",
  "emptyBody": "Ask residents to rate your service in the app (More → Feedback), for example with a sign at your counter."
}
